module.exports = __webpack_public_path__ + "static/media/32.d4cb85fc.jpg";